import BottomNavigation from "components/BottomNavigation"
import { SingleSelectField } from "components/RenderInput"
import UnsavedAlertModal from "components/UnsavedAlertModal"
import { FONTS } from "constants/fonts"
import { FORM_NAMES } from "constants/index"
import React, { useEffect, useState } from "react"
import { connect } from "react-redux"
import { Card, CardBody, Row, Col, CardHeader } from "reactstrap"
import { Field, isDirty, reset } from "redux-form"
import PhonePreview from "./phonePreview"
import ColorPicker from "components/ColorPicker"

const StyleTab = ({
  handleSave,
  handleBack,
  handleNext,
  isDirty,
  resetForm,
  tabIsActive,
}) => {
  const [showAlertModal, setShowAlertModal] = useState(false)

  useEffect(() => {
    if (!tabIsActive && isDirty) {
      setShowAlertModal(true)
    }
  }, [tabIsActive])

  return (
    <React.Fragment>
      <Row>
        <Col xl={8}>
          <Card>
            <CardHeader>
              <h4>Design the menu tabs</h4>
            </CardHeader>
            <CardBody>
              <Row className="my-3">
                <Col xs={12} md={3} xl={2} style={{ minWidth: "fit-content" }}>
                  <label>Menu Tab Color:</label>
                </Col>
                <Col xs={"auto"}>
                  <Field name="menu_tab_color" component={ColorPicker} />
                </Col>
              </Row>
              <Row className="my-3">
                <Col xs={12} md={3} xl={2} style={{ minWidth: "fit-content" }}>
                  <label>Menu Text Color:</label>
                </Col>
                <Col xs={"auto"}>
                  <Field name="menu_text_color" component={ColorPicker} />
                </Col>
              </Row>
              <Row className="my-3">
                <Col xs={12} md={3} xl={2} style={{ minWidth: "fit-content" }}>
                  <label>Menu Font:</label>
                </Col>
                <Col xs="auto">
                  <div style={{ width: "270px" }}>
                    <Field
                      name="menu_font"
                      component={SingleSelectField}
                      options={FONTS.map(font => ({
                        value: font.value,
                        label: font.text,
                      }))}
                      placeholder="Select Font Family"
                    />
                  </div>
                </Col>
              </Row>
            </CardBody>
          </Card>
          <BottomNavigation
            handleBack={handleBack}
            handleSave={handleSave}
            handleNext={handleNext}
          />
        </Col>
        <Col xl={4} className="mt-4 d-none d-xl-block">
          <PhonePreview />
        </Col>
      </Row>
      <UnsavedAlertModal
        isOpen={showAlertModal}
        onClose={() => {
          setShowAlertModal(false)
          resetForm()
        }}
        onSave={() => {
          handleSave()
          setShowAlertModal(false)
        }}
      />
    </React.Fragment>
  )
}

const mapStateToProps = state => ({
  isDirty: isDirty(FORM_NAMES.LANDING_SCREEN)(state, ...["menu.style"]),
})

const mapDispatchToProps = dispatch => ({
  resetForm: () => dispatch(reset(FORM_NAMES.LANDING_SCREEN)),
})

export default connect(mapStateToProps, mapDispatchToProps)(StyleTab)
